import { BreakpointObserver } from '@angular/cdk/layout';
import {
 ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnInit, Renderer2, ViewChild
} from '@angular/core';
import { BREAKPOINTS } from '@sparro/app/core/config/constants.config';


@Component({
  selector: 'uni-publication-entry-cards-group',
  templateUrl: './publication-entry-cards-group.component.html',
  styleUrls: ['./publication-entry-cards-group.component.scss']
})
export class PublicationEntryCardsGroupComponent implements OnInit {
  @Input() entries: any[];
  @Input() host: string;
  @Input() self: boolean = false;
  @Input() featured: boolean = false;
  @Input() publicationType: string;
  @Input() hasImageBadge: boolean = false;
  @Input() hasImageFooter: boolean = false;
  @Input() showTimestamp: boolean = false;
  @Input() footerType: ('disciplines' | 'score' | 'likes' | 'none') = 'none';

  // Sets style to card grids - display and alignment
  @Input() display: ('grid' | 'breakpoint') = 'grid';
  @Input() align: ('start' | 'center' | 'end') = 'center';

  visible_entries = [];
  limit: number = 0;
  isMobile: boolean = false;

  @ViewChild('grid', { read: ElementRef }) grid: ElementRef;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    public breakpointObserver: BreakpointObserver,
    private renderer: Renderer2
  ) { }

  ngOnInit() {
    // console.log(this.host, this.entries);
    this.initializeBreakpoints();
    if (this.display == 'breakpoint') {
      this.getEntries();
    }
    this.onResize();
  }

  initializeBreakpoints() {
    this.breakpointObserver.observe([
      BREAKPOINTS.below.md,
    ]).subscribe(result => {
      this.isMobile = result.breakpoints[BREAKPOINTS.below.md];
    });
  }

  ngAfterContentChecked() {
    this.changeDetectorRef.detectChanges();
  }

  ngAfterViewInit() {
    // Sets place-content as center by default
    if (this.isMobile) {
      this.renderer.setStyle(this.grid.nativeElement, 'place-content', 'center');
      this.changeDetectorRef.detectChanges();
    } else {
      this.renderer.setStyle(this.grid.nativeElement, 'place-content', this.align);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    const element = document.getElementById('grid-breakpoint');
    if (element !== null) {
      // console.log(element.offsetWidth);
      const card_limit = Math.floor(element.offsetWidth / 350);
      this.limit = card_limit;
      this.getEntries();
    }
    this.changeDetectorRef.detectChanges();
  }

  getEntries() {
    if (this.entries.length == this.limit) {
      this.visible_entries = this.entries;
    } else {
      this.visible_entries = this.entries.slice(0, this.limit);
      this.changeDetectorRef.detectChanges();
    }
  }
}
